import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import emailjs from "@emailjs/browser";

const CustomTripPlanner = () => {
  const form = useRef(); // Ref to capture form data
  const [formData, setFormData] = useState({
    fullName: "",
    destination: "",
    phone: "",
    email: ""
  });
  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const validate = () => {
    let tempErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9]{10}$/;

    if (!formData.fullName.trim()) tempErrors.fullName = "Full Name is required";
    if (!formData.destination.trim()) tempErrors.destination = "Destination is required";
    if (!emailRegex.test(formData.email)) tempErrors.email = "Valid email required";
    if (!phoneRegex.test(formData.phone)) tempErrors.phone = "10-digit phone number required";

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (errors[name]) setErrors({ ...errors, [name]: "" });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      setLoading(true);

      // --- EMAILJS CONFIGURATION ---
      emailjs.sendForm(
        'service_i8mllcq', 
        'template_i01vav4', 
        form.current, 
        'fFdw0sKjG6hYkRS5b'
      )
      .then((result) => {
          console.log("Email Sent:", result.text);
          setIsSubmitted(true);
      }, (error) => {
          console.error("Email Error:", error.text);
          alert("Failed to send inquiry. Please try again.");
      })
      .finally(() => setLoading(false));
    }
  };

  // --- Styles ---
  const containerStyle = { position: "relative", minHeight: "100vh", width: "100vw", display: "flex", justifyContent: "center", alignItems: "center", padding: "40px 20px", boxSizing: "border-box" };
  const glassCardStyle = { background: "rgba(0, 0, 0, 0.55)", backdropFilter: "blur(12px)", WebkitBackdropFilter: "blur(12px)", borderRadius: "24px", padding: "50px 40px", width: "100%", maxWidth: "600px", boxShadow: "0 8px 32px 0 rgba(0, 0, 0, 0.5)", border: "1px solid rgba(255, 255, 255, 0.15)", zIndex: 1, textAlign: isSubmitted ? "center" : "left" };
  const inputStyle = (hasError) => ({ width: "100%", padding: "14px 22px", backgroundColor: "rgba(255, 255, 255, 0.1)", color: "#fff", border: hasError ? "1px solid #ff4d4d" : "1px solid rgba(255, 255, 255, 0.3)", borderRadius: "50px", fontSize: "16px", outline: "none", boxSizing: "border-box" });

  return (
    <div style={containerStyle}>
      <div style={{ position: "fixed", inset: 0, zIndex: -10, backgroundImage: "url(/mainbg.jpg)", backgroundSize: "cover", backgroundPosition: "center" }} />
      <div style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.35)", zIndex: -5 }} />

      <div style={glassCardStyle}>
        {!isSubmitted ? (
          <>
            <h1 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "42px", textAlign: "center", color: "#fff", marginBottom: "40px", fontWeight: "bold" }}>Inquiry Form</h1>
            <form ref={form} onSubmit={handleSubmit}>
              <div style={{ marginBottom: "25px" }}>
                <label style={{ display: "block", fontSize: "22px", fontFamily: "'Cormorant Garamond', serif", color: "#fff", marginBottom: "8px" }}>Full Name</label>
                <input name="fullName" style={inputStyle(errors.fullName)} type="text" value={formData.fullName} onChange={handleChange} />
                {errors.fullName && <div style={{ color: "#ff4d4d", fontSize: "13px", marginTop: "6px" }}>{errors.fullName}</div>}
              </div>

              <div style={{ marginBottom: "25px" }}>
                <label style={{ display: "block", fontSize: "22px", fontFamily: "'Cormorant Garamond', serif", color: "#fff", marginBottom: "8px" }}>Destination you are planning</label>
                <input name="destination" style={inputStyle(errors.destination)} type="text" value={formData.destination} onChange={handleChange} />
                {errors.destination && <div style={{ color: "#ff4d4d", fontSize: "13px", marginTop: "6px" }}>{errors.destination}</div>}
              </div>

              <div style={{ marginBottom: "25px" }}>
                <label style={{ display: "block", fontSize: "22px", fontFamily: "'Cormorant Garamond', serif", color: "#fff", marginBottom: "8px" }}>Phone Number</label>
                <input name="phone" style={inputStyle(errors.phone)} type="tel" value={formData.phone} onChange={handleChange} />
                {errors.phone && <div style={{ color: "#ff4d4d", fontSize: "13px", marginTop: "6px" }}>{errors.phone}</div>}
              </div>

              <div style={{ marginBottom: "25px" }}>
                <label style={{ display: "block", fontSize: "22px", fontFamily: "'Cormorant Garamond', serif", color: "#fff", marginBottom: "8px" }}>Email Address</label>
                <input name="email" style={inputStyle(errors.email)} type="email" value={formData.email} onChange={handleChange} />
                {errors.email && <div style={{ color: "#ff4d4d", fontSize: "13px", marginTop: "6px" }}>{errors.email}</div>}
              </div>

              <button type="submit" disabled={loading} style={{ width: "100%", padding: "16px", backgroundColor: "transparent", color: "white", fontSize: "19px", fontWeight: "600", borderRadius: "50px", border: "2px solid white", cursor: "pointer", fontFamily: "'Cormorant Garamond', serif" }}>
                {loading ? "Sending..." : "Submit Inquiry"}
              </button>
            </form>
          </>
        ) : (
          <div style={{ padding: "40px 10px", textAlign: "center" }}>
            {/* Swapped airplane emoji with an <img> tag */}
            <div style={{ marginBottom: "25px" }}>
                <img 
                    src="logo/travxplogo.jpg" 
                    alt="Success Icon" 
                    style={{ width: "100px", height: "auto", display: "inline-block" }} 
                />
            </div>
            <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "38px", color: "#fff", marginBottom: "15px" }}>Thank you!</h2>
            <p style={{ color: "rgba(255,255,255,0.85)", fontSize: "20px", marginBottom: "35px", fontFamily: "'Cormorant Garamond', serif" }}>Our team will contact you shortly.</p>
            <Link to="/" style={{ display: "inline-block", padding: "14px 40px", border: "2px solid white", borderRadius: "50px", color: "white", textDecoration: "none", fontFamily: "'Cormorant Garamond', serif", fontWeight: "600" }}>Back to Home</Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomTripPlanner;